/* global appData ui */ // appData declared in the view
import hideLoading from './utils/loading/hideLoading';
import showLoading from './utils/loading/showLoading';
import shared from './utils/shared';

($ => {
	$(() => {
		const errorAlert = ui.alert(document.getElementById('errorMsg'), { open: false });
		function submitHandler({ valid }) {
			if (!valid || !shared.allowSubmit) {
				return false;
			}
			const $continueBtn = $('#continueBtn');
			errorAlert.close();
			showLoading($continueBtn);
			const ajaxData = {
				emailAddress: $('#emailAddress').val(),
				returnUrl: $('#returnUrl').val(),
				app: $('#app').val()
			};
			$.ajax({
				type: 'POST',
				url: `${appData.appPath}/signin/passwordHelp`,
				data: ajaxData,
				dataType: 'json',
				success(data) {
					$('#helpBody').html(data.html);
				},
				error() {
					hideLoading($continueBtn);
					errorAlert.open();
				}
			});
		}
		const $passwordHelpForm = document.getElementById('passwordHelpForm');
		ui.validator($passwordHelpForm, {
			fields: {
				emailAddress: { required: true, pattern: 'email' }
			},
			onSubmit: submitHandler
		});
	});
})(jQuery);
